<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-8">
        <div id="page-main">
          <section id="about">
            <br>
            <header><h3>Ethics Review Committee</h3></header>
            <img src="assets/img/ethics-review-committee.jpg">
            <hr>
            <p>
              The Ethics Review Committee (ERC, FH&SS/UOR) is established in 2017 at the Faculty of Humanities and
              Social Sciences, University of Ruhuna to provide necessary guidance, advice, decision and approval to
              conduct research related to all the disciplines of Humanities and Social Sciences while protecting the
              research ethics. The policy of the Faculty of Humanities and Social Sciences is that all research should
              be conducted in accordance with research ethics.
            </p>
            <hr>
          </section>
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

      <!--SIDEBAR Content-->
      <div class="col-md-4">
        <div id="page-sidebar" class="sidebar">
          <br>
          <aside id="our-professors">
            <header>
              <h5>Committee Members</h5>
            </header>
            <div class="section-content">
              <div class="professors">
                <aside>
                  <header>
                    <b>Chair</b>
                    <figure class="professor-description">Prof. H I G C Kumara
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Secretary</b>
                    <figure class="professor-description">
                      Dr. K H Ramanayaka<br>
                    </figure>
                  </header>
                </aside>
                <aside>
                  <header>
                    <b>Members</b>
                    <figure class="professor-description">
                      Prof. Upali Pannilage<br>
                      Dr. D P P G Liyanage<br>
                    </figure>
                  </header>
                </aside>
                <br>
                <hr>
                <aside>
                  <header>
                    <b><a href="assets/docs/ethics_review_application_form_humanities_and_sociel_sciences_search.pdf">
                      Download Ethics Review Application Form Humanities and Social Sciences Research
                    </a></b>
                    <figure class="professor-description">
                    </figure>
                  </header>
                </aside>
              </div><!-- /.professors -->
            </div><!-- /.section-content -->
          </aside><!-- /.our-professors -->
        </div><!-- /#sidebar -->
      </div><!-- /.col-md-4 -->
    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
